;(function($){
    


    $(function(){ 

 /* Bild und Video Slider - DCE */
        $('.thumbnail-carousel').each(function(){

            var id = $(this).attr('data-id');

            $('#thumbnail-carousel-'+id).flexslider({
                animation: "slide",
                controlNav: false,
                animationLoop: false,
                slideshow: false,
                itemWidth: 192,
                itemMargin: 11,
                minItems: 6,
                maxItems: 6,
                pauseOnAction: true,
                asNavFor: '#big-view-'+id
            });
        });


        var curslide = 0;
        function initializeBigViewSlider(curslide){
            $('.big-view').each(function(){

                var id = $(this).attr('data-id');
                var target = '#big-view-'+id;

                $(target).flexslider({
                    animation: "slide",
                    //directionNav: true,
                    animationLoop: false,
                    slideshow: false,
                    sync: "#thumbnail-carousel-"+id,
                    pauseOnAction: true,
                    start: function(slider) { // Fires when the slider loads the first slide
                        format_videos();

                        var slide_count = slider.count - 1;
                        $(slider)
                            .find('img.lazy:nth-child(-n+3)')
                            .each(function() {
                              var src = $(this).attr('data-src');
                              $(this).attr('src', src).removeAttr('data-src');
                            });
                    },
                    before: function(slider) { // Fires asynchronously with each slider animation
                      var slides     = slider.slides,
                          index      = slider.animatingTo,
                          $slide     = $(slides[index]),
                          $img       = $slide.find('img[data-src]'),
                          current    = index,
                          nxt_slide  = current + 1,
                          prev_slide = current - 1;

                      $slide
                        .parent()
                        .find('img.lazy:eq(' + current + '), img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')')
                        .each(function() {
                          var src = $(this).attr('data-src');
                          $(this).attr('src', src).removeAttr('data-src');
                        });
                    },
                    after: function(slider) {


                        /*stop videos from playing after slide*/
                        var nextslide = slider.animatingTo;

                        if( curslide != nextslide ) {
                            $(target).find('iframe').each(function(){
                                var $this = $(this);

                                if ($this.attr('src') != '') {
                                    $this.attr('src','');
                                }
                                //display previewimage and play-button
                                $(target).find('.video-preview-img').show();
                                $(target).find('.youtube-video.with-preview .load-video').show();
                            });
                        }

                        curslide = nextslide;


                    },
                });


            });

            

        }
        initializeBigViewSlider(curslide);
        $(document).ready(function(){
            $('.big-view').each(function(){
                var flexslider = $(this).data('flexslider');   
                if( flexslider != undefined){
                        flexslider.resize();
                }
            });

          
        });





        function format_videos() {
            $('.video-wrapper.format-video').each(function(){
                $this = $(this);
                var itemwidth = $this.width();
                var itemHeight = $this.height();
                var format = $this.data('format');

                if(format == 'image'){
                    if( $this.find('img').height() > 0 ){
                        var newheight = $this.find('img').height();
                    }else{
                        var newheight = $this.height();
                    }
                }else{
                    format = format.split('/');
                    var widthformat = format[0];
                    var heightformat = format[1];
                    var newheight = ( parseInt(itemwidth) / parseInt(widthformat) ) * parseInt(heightformat);
                }


                $this.height(newheight);
                $this.find('iframe').height(newheight);
            })
        }
        



    });
})(jQuery);